import { Component, ViewChild, Output, Input, EventEmitter, ViewChildren, QueryList, ChangeDetectionStrategy } from '@angular/core';
import { DatetimePickerComponent } from '../datetime-picker/datetime-picker.component';
import { ScheduleItem, Trigger } from './models';
import { TriggerItemComponent } from './trigger-item.component';
import { SvgIconComponent } from '../icons/svg-icon.component';

@Component({
    templateUrl: './schedule-item.component.html',
    selector: 'ep-schedule-item',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatetimePickerComponent, SvgIconComponent, TriggerItemComponent]
})
export class ScheduleItemComponent {
    @Input() readonly = false;
    @Input() showDates = true;
    @Input() hideTriggerStart = false;
    @Input() hideTriggerEnd = false;
    @Input() requireWeekdaySelection = false;
    @Input() validateTriggerTimes = false;
    @Input() requireAtLeastOneTrigger = false;

    @Input() scheduleItem: ScheduleItem = new ScheduleItem();
    @Output() scheduleItemChange = new EventEmitter<ScheduleItem>();

    @ViewChild('enddatepicker') enddatepicker: DatetimePickerComponent;
    @ViewChild('startdatepicker') startdatepicker: DatetimePickerComponent;
    @ViewChildren(TriggerItemComponent) triggerItems: QueryList<TriggerItemComponent>;

    dateRangeError: string | null = null;

    constructor() {
        this.scheduleItem.StartDate = new Date();
        this.scheduleItem.StartDate.setHours(0, 0, 0, 0);
    }

    onStartDateChanged() {
        this.validateDateRange();
        this.scheduleItemChange.emit(this.scheduleItem);
    }

    onEndDateChanged() {
        this.validateDateRange();
        this.scheduleItemChange.emit(this.scheduleItem);
    }

    private validateDateRange(): void {
        this.dateRangeError = null;

        const start = this.scheduleItem?.StartDate ? new Date(this.scheduleItem.StartDate) : null;
        const end = this.scheduleItem?.EndDate ? new Date(this.scheduleItem.EndDate) : null;

        if (!start || !end) return;

        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        if (end < start) {
            this.dateRangeError = 'Expire date cannot be earlier than the start date.';
        }
    }

    get isDateRangeValid(): boolean {
        return !this.dateRangeError;
    }

    addTrigger() {
        const trigger = {} as Trigger;
        trigger.Weekdays = '';
        trigger.StartTime = '08:00:00';
        trigger.EndTime = '16:00:00';
        this.scheduleItem.Triggers.push(trigger);
        this.scheduleItemChange.emit(this.scheduleItem);
    }

    removeTrigger(trigger: Trigger) {
        const index = this.scheduleItem.Triggers.indexOf(trigger);
        if (index >= 0) {
            this.scheduleItem.Triggers.splice(index, 1);
            this.scheduleItemChange.emit(this.scheduleItem);
        }
    }

    triggerChange() {
        this.scheduleItemChange.emit(this.scheduleItem);
    }

    clearValidationErrors(): void {
        this.dateRangeError = null;
    }

    get isScheduleValid(): boolean {
        let isValid = true;

        if (!this.isDateRangeValid) {
            return false;
        }

        this.triggerItems.forEach(x => {
            if (isValid) {
                isValid = x.isTriggerValid;
            }
        });

        return isValid;
    }
}